import React from 'react';

const Payment = () => {
         return (
                  <div>
                           <h1 className="text-center header-text">Payment system comeing soon</h1>
                  </div>
         );
};

export default Payment;